app.controller("AddLanguageToProgram", ["$scope", "$uibModalInstance", "Language", "params",
    function ($scope, $uibModalInstance, Language, params) {

        $scope.checked = {};
        Language.containersList().then(function (containers) {
            return $scope.containers = containers
        });

        $scope.copyContainers = function () {
            var containers = _($scope.checked).pickBy(function (t) {
                return t;
            }).keys().value();
            var program = params.program;
            Language.copyToProgram({
                containers: containers,
                program: program
            }).then(function (result) {
                $uibModalInstance.close();
            })
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);
